import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import InfoRequestForm from './InfoRequestForm';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { getMatters, getGroups } from './ducks';
import { removeEmptyKeys } from '../validations';

// We use this to reinitialize values as we fiddle around in the form
const initialValues = {
  requestMatter: null,
  serviceLine: null,
  serviceGroup: null,
  topic: '',
  requestDescription: '',
  researchCode: '',
  classification: null,
  patientInfoRequested: null,
  permitAttachment: null,
  requestHasDeadline: null,
  deadline: moment(),
  deadlineArgument: '',
  customerIsNotNotifier: null,
  customerEmail: '',
  requestAttachment: null,
  requestAttachment2: null,
  requestAttachment3: null,
  costcenter: '',
  billingAddress: '',
  researchProjectNumber: '',
  contactNumber: '',
  requestForContact: null,
  requestIsReviewed: false,
};

const InfoRequest = props => {
  const [matters, setMatters] = useState();
  const [groups, setGroups] = useState();
  const [requireds, setRequireds] = useState({});
  const { formId, edit } = props;
  const { orderId } = useParams();

  // Fetch matters
  useEffect(() => {
    const update = async () => {
      try {
        const [newMatters, newGroups] = await Promise.all([
          getMatters(),
          getGroups(),
        ]);
        setMatters(newMatters);
        setGroups(newGroups);
      } catch (e) {
        console.error(
          'Error in infoRequest when fetching matters and groups:',
          e
        );
      }
    };

    update();
  }, []);

  const validate = values => {
    const errors = {};

    Object.keys(requireds).forEach(required => {
      if (requireds[required] && !values[required]) {
        errors[required] = 'Vaadittu';
      }
    });

    if (!!values.requestHasDeadline && !values.deadline) {
      errors.deadline = 'Vaadittu';
    }

    if (!!values.requestHasDeadline && !values.deadlineArgument) {
      errors.deadlineArgument = 'Vaadittu';
    }

    if (values.deadline?.isBefore(moment(), 'day')) {
      errors.deadline = 'Aika ei voi olla menneisyydessä';
    }

    if (values.patientInfoRequested && !values.permitAttachment) {
      errors.permitAttachment = 'Vaadittu';
    }

    if (values.customerIsNotNotifier && !values.customerEmail) {
      errors.customerEmail = 'Vaadittu';
    }

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            serviceLine: values.serviceLine?.map(o => o.value),
            serviceGroup: values.serviceGroup?.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => {
        return (
          <FormWrapper
            {...props}
            title="Tietopalvelupyynnöt"
            matters={matters}
            groups={groups}
            setRequireds={setRequireds}
            formik={formikProps}
            Component={InfoRequestForm}
            hideSubmitButton={!formikProps.values?.requestMatter}
          />
        );
      }}
    </Formik>
  );
};

export default InfoRequest;
